


  <div *ngIf="!checkV2Design();else medical_fundraising">
    <!--banner section-->
    <app-banner [section]="data?.section_1"></app-banner>

    <app-medical-seo *ngIf="page==='medical-fundraising'"></app-medical-seo>

    <!--causes section-->
    <app-medical-causes [section]="data?.section_2"></app-medical-causes>

    <!--use of crowdfunding section-->
    <app-crowdfunding-use [section]="data?.section_3"></app-crowdfunding-use>

    <!--testimonials section-->
    <app-testimonials [section]="data?.section_4" class="{{data?.section_4?.bg_image}}"></app-testimonials>

    <!--faqs section-->
    <app-faqs [section]="data?.section_5"></app-faqs>

    <!--What we offer-->
    <app-what-ketto-offers [section]="data?.section_6" class="{{data?.section_6?.bg_image}}"></app-what-ketto-offers>

    <!--active fr section-->
    <app-active-fundraisers *ngIf="data?.cause" [section]="data?.section_7" [cause]="data?.cause"></app-active-fundraisers>

    <!--query section-->
    <app-landing-footer></app-landing-footer>
  </div>

  <ng-template #medical_fundraising>

    <!--banner section-->
    <app-new-banner [section]="data?.section_1"></app-new-banner>

    <app-medical-seo *ngIf="checkV2Design()" [section]="data?.section_9"></app-medical-seo>

    <!--causes section-->
    <app-new-medical-causes  *ngIf="!isMemorial" [section]="data?.section_2"></app-new-medical-causes>
    <app-cost-cover-info  *ngIf="isMemorial" [section]="data?.section_2"></app-cost-cover-info>

    <!--use of crowdfunding section-->
    <app-new-crowdfunding-use [section]="data?.section_3" *ngIf="!isMemorial"></app-new-crowdfunding-use>

    <!--how it works memorial section-->
    <app-how-it-works-mem *ngIf="isMemorial"></app-how-it-works-mem>

    <!--What we offer-->
    <app-new-what-ketto-offers [section]="data?.section_6" class="{{data?.section_6?.bg_image}}"></app-new-what-ketto-offers>

    <!--testimonials section-->
    <app-new-testimonials [section]="data?.section_4" class="{{data?.section_4?.bg_image}}"></app-new-testimonials>

    <!--active fr section-->
    <app-new-active-fundraisers *ngIf="data?.cause" [section]="data?.section_7" [cause]="data?.cause"></app-new-active-fundraisers>

    <!--faqs section-->
    <app-new-faqs [section]="data?.section_5" *ngIf="!isMemorial"></app-new-faqs>

    <!--Sip monthly giving banner-->
    <app-fundraiser-sipbanner [config]="{
        hideEndText: true,
        hideDock: true,
        info_3: 'causespage',
        queryParams: { utm_term: 'causespage', utm_content: 'banner' }
      }">
    </app-fundraiser-sipbanner>

  </ng-template>

